<template>
  <div>
    <header-component />
    <b-container fluid>
      <div class="login_form">
        <h3 class="text-center">Sign In</h3>
        <p class="text-center mb-5">Identify yourself by entering email and password.</p>
        <b-form>
          <b-form-group
            id="email-label"
            label-for="email"
            description="We'll never share your email with anyone else."
          >
            <b-form-input id="email" type="email" required placeholder="Enter Email"></b-form-input>
          </b-form-group>

          <b-form-group id="password-label" label-for="password">
            <b-form-input id="password" type="password" required placeholder="Enter Paswword"></b-form-input>
          </b-form-group>

          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
        <div class="clearfix">
          <b-link class="d-inline-block pt-4 float-left" to="/registration">Registration</b-link>
          <b-link class="d-inline-block pt-4 float-right">Forgot Password?</b-link>
        </div>

        <p class="d-block mt-5 text-center">Login via social network</p>
        <a href="#" class="fb">
            <img src="@/assets/images/icons/fb.png" alt="">
            <span>Facebook</span>
        </a>
      </div>
    </b-container>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer2.vue";

export default {
  components: {
    headerComponent,
    footerComponent
  }
};
</script>

<style lang="scss" scoped>
.login_form {
  padding: 60px 0 100px;
  width: 100%;
  max-width: 600px;
  display: block;
  margin: auto;
  form {
    .form-group {
      margin-bottom: 30px;
      input {
        height: 50px;
        border: 1px solid $base-color-lightblue;
        background: $bg-lightgray;
        text-indent: 15px;
      }
    }
    button.btn {
      height: 50px;
      width: 100%;
      background: $base-color-blue;
      margin-top: 10px;
      text-transform: uppercase;
    }
  }
  .fb {
          text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $base-blue-nav;
    color: #fff;
    height: 50px;
    border-radius: 4px;
    text-decoration: none;
    img {
        margin-right: 15px;
    }
    span {
        text-transform: uppercase;
    }
  }
}
</style>